import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { RegisterComponent } from './register/register.component';



@NgModule({
  declarations: [LoginComponent, RegisterComponent],
  imports: [CommonModule,
  			FormsModule,
  			ReactiveFormsModule,
  			RouterModule],
  providers: [CookieService],
  exports: [LoginComponent,
  			FormsModule,
  			ReactiveFormsModule]
})

export class AuthenticationModule { }
